// src/components/GridControls.tsx

import React from 'react';
import { NumericInput } from './NumericInput';
import { CustomSelect } from './CustomSelect';
import { DropdownOption } from '../types/Dropdown';
import { Layout } from '../types/Layout';
import { AvailableWidgets } from '../types/AvailableWidgets';
import './GridControls.scss';

interface GridControlsProps {
    layout: Layout;
    onRowChange: (rows: number) => void;
    onColumnChange: (columns: number) => void;
    onWidgetChange: (rowIndex: number, colIndex: number, widgetName: string | null) => void;
}

export const GridControls: React.FC<GridControlsProps> = ({
    layout,
    onRowChange,
    onColumnChange,
    onWidgetChange,
}) => {

    const widgetOptions: DropdownOption[] = [{ value: undefined, label: 'Remove widget' }, ...AvailableWidgets.map((widget) => ({
        value: widget.key,
        label: widget.displayName,
    }))];

    return (
        <div className="grid-controls">
            <CustomSelect
                options={widgetOptions}
                value={layout.main?.widgetName || ''}
                onChange={(value) => onWidgetChange(-1, -1, value || null)}
                placeholder="Select widget"
            />
            <div className="size-controls">
                <NumericInput
                    label='rows'
                    value={layout.rows}
                    minimum={0}
                    maximum={4}
                    onValueChange={onRowChange}
                />
                <NumericInput
                    label='columns'
                    value={layout.columns}
                    minimum={0}
                    maximum={4}
                    onValueChange={onColumnChange}
                />
            </div>
            <div className="widget-controls">
                {layout.grid.map((row, rowIndex) => (
                    <div key={rowIndex} className="row-widgets">
                        <div className="column-controls">
                            {row.cells.map((cell, colIndex) => (
                                <div key={colIndex} className="widget-select">
                                    <CustomSelect
                                        options={widgetOptions}
                                        value={cell.widgetName || ''}
                                        onChange={(value) => onWidgetChange(rowIndex, colIndex, value || null)}
                                        placeholder="Select widget"
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};